import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { style: {"margin-top":"30px"} }
const _hoisted_2 = {
  key: 0,
  class: "needs-sign"
}
const _hoisted_3 = { class: "needs-sign-title" }
const _hoisted_4 = { class: "needs-sign-count" }
const _hoisted_5 = { class: "needs-sign-list" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "home-process-info" }
const _hoisted_8 = { class: "home-process-name" }
const _hoisted_9 = { class: "home-process-meta" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "needs-sign"
}
const _hoisted_14 = { class: "needs-sign-title" }
const _hoisted_15 = { class: "needs-sign-count" }
const _hoisted_16 = { class: "needs-sign-list" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "home-process-info" }
const _hoisted_19 = { class: "home-process-name" }
const _hoisted_20 = { class: "home-process-meta" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.needsSign.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, [
            _cache[0] || (_cache[0] = _createTextVNode("Needs your signature", -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.needsSign.length), 1)
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "needs-sign-sub" }, "Review and sign these processes — your signature is due.", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.needsSign, (n, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "home-process",
                onClick: ($event: any) => (_ctx.$router.push('/playbook/' + n.Slug))
              }, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "home-process-icon" }, [
                  _createElementVNode("svg", {
                    viewBox: "0 0 24 24",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("path", { d: "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2" })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(n.Name), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (n.HasPrevSignOff)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Updated — please re-sign"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "New — please sign"))
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn home-process-sign",
                  onClick: _withModifiers(($event: any) => (_ctx.$router.push('/playbook/' + n.Slug)), ["stop"])
                }, "Sign", 8, _hoisted_12)
              ], 8, _hoisted_6))
            }), 128))
          ])
        ]))
      : (_ctx.updated.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createElementVNode("h3", _hoisted_14, [
              _cache[3] || (_cache[3] = _createTextVNode("Recently updated", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.updated.length), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "needs-sign-sub" }, "The latest changes", -1)),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updated, (n, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "home-process",
                  onClick: ($event: any) => (_ctx.$router.push('/playbook/' + n.Slug))
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "home-process-icon" }, [
                    _createElementVNode("svg", {
                      viewBox: "0 0 24 24",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M12 8v4l2 2" }),
                      _createElementVNode("path", { d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(n.Name), 1),
                    _createElementVNode("div", _hoisted_20, "Updated — " + _toDisplayString(n.LastModifiedString), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn home-process-sign",
                    onClick: _withModifiers(($event: any) => (_ctx.$router.push('/playbook/' + n.Slug)), ["stop"])
                  }, "Open", 8, _hoisted_21)
                ], 8, _hoisted_17))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}